const getShortFormat = (locale: string) =>
  new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short'
  });

const getLongFormat = (locale: string) =>
  new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

export const formatDate = (
  date: Date | string,
  locale: string = 'en',
  mode?: 'short' | 'long'
): string => {
  try {
    if (!mode || mode === 'long') {
      return getLongFormat(locale).format(new Date(date));
    } else {
      return getShortFormat(locale).format(new Date(date));
    }
  } catch (e) {
    return 'Invalid date';
  }
};

export const oneMonth = 1000 * 60 * 60 * 24 * 30;
